// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1u4Ro{position:relative}._1yzaC{-ms-flex-direction:column;flex-direction:column;width:154px}._2oh2t,._1yzaC{display:-ms-flexbox;display:flex}._2oh2t{-ms-flex-align:center;align-items:center;-ms-flex-pack:end;font-size:12px;gap:3px;height:18px;justify-content:flex-end;margin-top:2px;text-wrap-mode:nowrap}._2oh2t>svg{height:18px;width:15px}._1y1Gq{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}._1H9ye{position:absolute;top:-21px}._1H9ye,html[dir=ltr] ._1H9ye{left:13px}html[dir=rtl] ._1H9ye{right:13px}.HhHXl{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;position:relative}.HhHXl h3,._91sDA{font-size:17px;font-weight:800;position:absolute;top:-21px}._3Gm_X{background:#ededee;border-radius:4px;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;font-family:Proxima Nova,sans-serif;font-size:17px;gap:7px;height:18px;line-height:18px;margin-top:2px;padding-left:7px;position:relative;width:125px}._3Gm_X ._3S_eC,._3Gm_X svg{height:18px;width:15px}._3Gm_X ._22o51{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;gap:2px}._3Gm_X ._1VY02{font-size:14px}._2fYpD,.KXHxd{height:18px;width:13px}._1q6Ry{height:15px;width:15px}._1VNUg{height:18px;width:15px}", ""]);
// Exports
exports.locals = {
	"labels": "_1u4Ro",
	"labelContainer": "_1yzaC",
	"label": "_2oh2t",
	"labelInner": "_1y1Gq",
	"day": "_1H9ye",
	"summary": "HhHXl",
	"summary__header": "_91sDA",
	"summary__row": "_3Gm_X",
	"icon": "_3S_eC",
	"avarageSummary": "_22o51",
	"avarageSummary__text": "_1VY02",
	"icon--bgm": "_2fYpD",
	"icon--foods": "KXHxd",
	"icon--medications": "_1q6Ry",
	"icon--activities": "_1VNUg"
};
module.exports = exports;
